import { connect } from 'react-redux';
import AddPoc from './addPoc';
import { bindActionCreators } from 'redux';
import { addPoc, getPocById, editPoc } from 'services/redux/sales/poc/action'


const mapStateToProps = state => ({
    pocDetails: state.pocReducer.pocDetails,
    pocById: state.pocReducer.pocById,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    addPoc,
    getPocById,
    editPoc
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(AddPoc);
